<template>
  <div id="app" style="width: 100%">
    <!-- 标题栏 -->
    <div v-if="!recordDetail" class="page-header">
      <div class="page-title">云端录像</div>
      <div class="page-header-btn">
        <span style="margin-right: 6px; color: #606266; font-size: 13px;">节点选择:</span>
        <el-select size="mini" @change="chooseMediaChange" style="width: 16rem; margin-right: 1rem;" v-model="mediaServerId" placeholder="请选择">
          <el-option
            v-for="item in mediaServerList"
            :key="item.id"
            :label="item.id"
            :value="item.id">
          </el-option>
        </el-select>
        <el-button icon="el-icon-refresh-right" circle size="mini" :loading="loading" @click="getRecordList()"></el-button>
      </div>
    </div>

    <!-- 录像详情返回栏 -->
    <div v-if="recordDetail" class="page-header">
      <el-page-header @back="backToList" content="云端录像"></el-page-header>
    </div>

    <!-- 表格区域 -->
    <div v-if="!recordDetail" class="table-card">
      <el-table :data="recordList" style="width: 100%" :height="winHeight">
        <el-table-column prop="app" label="应用名">
        </el-table-column>
        <el-table-column prop="stream" label="流ID">
        </el-table-column>
        <el-table-column prop="time" label="时间">
        </el-table-column>
        <el-table-column label="操作" width="360" fixed="right">
          <template slot-scope="scope">
            <el-button size="medium" icon="el-icon-folder-opened" type="text" @click="showRecordDetail(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="float: right; padding: 12px 16px;"
        @size-change="handleSizeChange"
        @current-change="currentChange"
        :current-page="currentPage"
        :page-size="count"
        :page-sizes="[15, 25, 35, 50]"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>

    <cloud-record-detail ref="cloudRecordDetail" v-if="recordDetail" :recordFile="chooseRecord" :mediaServerId="mediaServerId" :mediaServerPath="mediaServerPath"></cloud-record-detail>
  </div>
</template>

<script>
	import uiHeader from '../layout/UiHeader.vue'
	import cloudRecordDetail from './CloudRecordDetail.vue'
  import MediaServer from './service/MediaServer'
	export default {
		name: 'app',
		components: {
			uiHeader, cloudRecordDetail
		},
		data() {
			return {
        mediaServerList: [], // 滅体节点列表
        mediaServerId: null, // 媒体服务
        mediaServerPath: null, // 媒体服务地址
        recordList: [], // 设备列表
        chooseRecord: null, // 媒体服务

        updateLooper: 0, //数据刷新轮训标志
        winHeight: window.innerHeight - 250,
        currentPage:1,
        count:15,
        total:0,
        loading: false,
        mediaServerObj : new MediaServer(),
        recordDetail: false

			};
		},
		computed: {

		},
		mounted() {
			this.initData();
		},
		destroyed() {
			// this.$destroy('videojs');
		},
		methods: {
			initData: function() {
			  // 获取媒体节点列表
			  this.getMediaServerList();
			  // this.getRecordList();
			},
      currentChange: function(val){
        this.currentPage = val;
        this.getRecordList();
      },
      handleSizeChange: function(val){
        this.count = val;
        this.getRecordList();
      },
      getMediaServerList: function (){
        let that = this;
        that.mediaServerObj.getOnlineMediaServerList((data)=>{
          that.mediaServerList = data.data;
          if (that.mediaServerList.length > 0) {
            that.mediaServerId = that.mediaServerList[0].id
            that.setMediaServerPath(that.mediaServerId);
            that.getRecordList();
          }
        })
      },
      setMediaServerPath: function (serverId) {
        let that = this;
        let i;
        for (i = 0; i < that.mediaServerList.length; i++) {
          if (serverId === that.mediaServerList[i].id) {
            break;
          }
        }
        let port = that.mediaServerList[i].httpPort;
        if (location.protocol === "https:" && that.mediaServerList[i].httpSSlPort) {
          port = that.mediaServerList[i].httpSSlPort
        }
        that.mediaServerPath = location.protocol + "//" + that.mediaServerList[i].streamIp + ":" + port
        console.log(that.mediaServerPath)
      },
      getRecordList: function (){
        let that = this;
        this.$axios({
          method: 'get',
          url:`/record_proxy/${that.mediaServerId}/api/record/list`,
          params: {
            page: that.currentPage,
            count: that.count
          }
        }).then(function (res) {
          console.log(res)
          if (res.data.code === 0) {
            that.total = res.data.data.total;
            that.recordList = res.data.data.list;
          }
          that.loading = false;
        }).catch(function (error) {
          console.log(error);
          that.loading = false;
        });
      },
      backToList(){
			  this.recordDetail= false;
      },
      chooseMediaChange(val){
          console.log(val)
          this.total = 0;
          this.recordList = [];
          this.setMediaServerPath(val);
          this.getRecordList();
      },
      showRecordDetail(row){
        this.recordDetail = true;
        this.chooseRecord = row;
        // 查询是否存在录像
        // this.$axios({
        //   method: 'delete',
        //   url:`/record_proxy/api/record/delete`,
        //   params: {
        //     page: this.currentPage,
        //     count: this.count
        //   }
        // }).then((res) => {
        //   console.log(res)
        //   this.total = res.data.data.total;
        //   this.recordList = res.data.data.list;
        // }).catch(function (error) {
        //   console.log(error);
        // });

      },
      deleteRecord(){
			  // TODO
        let that = this;
        this.$axios({
          method: 'delete',
          url:`/record_proxy/api/record/delete`,
          params: {
            page: that.currentPage,
            count: that.count
          }
        }).then(function (res) {
          console.log(res)
          if (res.data.code === 0) {
            that.total = res.data.data.total;
            that.recordList = res.data.data.list;
          }
        }).catch(function (error) {
          console.log(error);
        });
      },


		}
	};
</script>

<style>
/* 标题栏卡片 */
.page-header {
  background: #FFFFFF;
  margin-bottom: 16px;
  padding: 16px 20px;
  border-radius: 6px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04), 0 4px 16px rgba(0, 0, 0, 0.04);
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: box-shadow 0.3s ease;
}
.page-header:hover {
  box-shadow: 0 2px 14px rgba(64, 158, 255, 0.06), 0 8px 32px rgba(0, 0, 0, 0.07);
}

.page-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 6px;
}

.page-header-btn {
  text-align: right;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

/* 表格卡片容器 */
.table-card {
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04), 0 4px 16px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/CloudRecord.vue